const sRootFont = "16px";
const viewportSmall = 400;
const viewportMedium = 576;

export { viewportSmall as a, sRootFont as s, viewportMedium as v };

//# sourceMappingURL=tokens-8f54bd51.js.map